import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from 'lodash';
// import PropTypes from 'prop-types';
import Row from "../../shared/components/Row";
import Card from "../../shared/components/Card";
import CardHeader from "../../shared/components/card-header/CardHeader";
import {I18nUtils} from "../../../i18n/I18nUtils";
import HeaderSearchRefreshFilterOptions from "../../shared/components/HeaderSearchRefreshFilterOptions";
import Paginator from "../../shared/components/Paginator";
import TypeDocumentsTable from "./TypeDocumentsTable";
import CardBody from "../../shared/components/CardBody";
import * as typeDocumentsActions from '../actions/typeDocumentsActions';
import StateManager from "../../shared/utils/StateManager";

class TypeDocumentsCard extends React.Component {

    STATE_MANAGER_KEY = 'WORKERS_CARD';

    constructor(props){
        super(props);

        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);

        this.state = StateManager.getState(this.STATE_MANAGER_KEY);
    }


    componentWillMount(){
        this.getTypeDocuments();
    }

    componentDidUpdate( prevProps, prevState ){
        if ( prevState.search !== this.state.search
            || prevState.filter !== this.state.filter
            || prevState.page !== this.state.page ){
            this.getTypeDocuments();
        }
        StateManager.saveState(this.STATE_MANAGER_KEY, this.state);
    }

    getTypeDocuments(){
        this.props.typeDocumentsActions.getTypeDocuments(this.state.page, this.state.search, this.state.filter);
    }

    onRefresh(){
        this.getTypeDocuments()
    }

    onSearch(search){
        this.setState({ search: search, page: 1 });
    }

    onPage(page){
        this.setState({ page })
    }

    renderFilterName(){

        const states = _.keyBy(this.props.schemeTypes, 'id');
        if (states && states[this.state.filter]){
            return states[this.state.filter].name;
        }
        return '';

    }

    renderHeaderOptions(){

        const filterOptions = this.props.schemeTypes.map((scheme) => {
            return {
                title: scheme.name,
                active: scheme.id === this.state.filter,
                onClick: () => {
                    this.setState({ filter: scheme.id, page: 1 });
                },
            }
        });

        return(
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                onSearch={this.onSearch}
                searchText={this.state.search}
                filterOptions={filterOptions}
            />
        );

    }


    render() {
        return (
            <Row>
                <Card loading={this.props.typeDocumentLoading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TIPOS_DE_DOCUMENTOS').toUpperCase()}
                        subtitle={this.renderFilterName()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody>
                        <TypeDocumentsTable data={this.props.typeDocument} error={this.props.typedocumentsError}/>
                        <Paginator
                            data={this.props.typeDocumentPagination}
                            onPage={this.onPage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

const mapStateToProps = state => {

    let errorMessage = state.typedocuments.typeDocumentError;
    if (!errorMessage && Object.keys(state.typedocuments.typeDocuments).length === 0 && !state.typedocuments.typeDocumentsLoading){
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }

    let schemaOptions = state.schemaType.schemaType.map((schema) => {
        return {
            id: schema.id,
            name: schema.name,
        };
    });
    schemaOptions = [{id: 0, name: I18nUtils.tr('TR_TODOS')}, ...schemaOptions];

    return({
        typeDocument: state.typedocuments.typeDocuments,
        typeDocumentPagination: state.typedocuments.typeDocumentsPagination,
        typeDocumentLoading: state.typedocuments.typeDocumentsLoading,
        typedocumentsError: errorMessage,
        schemeTypes: schemaOptions,
    });
};

const mapDispatchToProps = dispatch => ({
    typeDocumentsActions: bindActionCreators(typeDocumentsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TypeDocumentsCard);

TypeDocumentsCard.propTypes = {};

TypeDocumentsCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/TypeDocumentsCard.js